import { gql } from '@apollo/client';

export const CHECK_WS_CONNECTION = gql`
    subscription checkWSConnection($clientId: String!) {
        checkWSConnection(clientId: $clientId)
    }
`;
